module.exports = __webpack_public_path__ + "img/linkedin.5805a2ac.svg";